import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useSearchOrigin = () => {
  const [loading, setLoading] = useState(true);
  const [searchBranch, setSearchBranch] = useState({});

  const { enqueueSnackbar } = useSnackbar();

  const getSearchOrigin = (input = '') => {
    setLoading(true);

    axiosClient
      .get(`Product/Origin/Search?SearchTerm=${input}`)
      .then(res => {
        if (res.status === 200) {
          setSearchBranch(res.data.value);
        } else {
          enqueueSnackbar(res.message, { variant: 'error' });
        }
      })
      .catch(err => {
        enqueueSnackbar(err.message, { variant: 'error' });
      })
      .finally(() => setLoading(false));
  };

  return [getSearchOrigin, loading, searchBranch];
};

export default useSearchOrigin;
